export default function isEmptyObject(obj: Record<string, unknown>) : boolean {
  return !Object.keys(obj).length;
}
